// @flow
import * as React from 'react'
import Tooltip from 'ui/atoms/Tooltip'
import ButtonIcon from 'ui/ButtonIcon'
import Icons from 'ui/Icons'

type Props = {
  onPublicFormClick: () => void,
  resourceId: string | number,
  resourceEnabled: boolean,
}

function FormControlsPublicLinkButton({
  onPublicFormClick,
  resourceId,
  resourceEnabled,
}: Props): React.Node {
  const onPublicForm = React.useCallback(
    (e) => {
      e.stopPropagation()
      e.preventDefault()
      onPublicFormClick()
    },
    [onPublicFormClick]
  )

  return (
    <Tooltip label="Public URL">
      <p>
        <ButtonIcon rounded disabled={!resourceEnabled} onClick={onPublicForm}>
          <Icons.Link size="4" />
        </ButtonIcon>
      </p>
    </Tooltip>
  )
}

export default FormControlsPublicLinkButton
